import React from "react";
import { Redirect, Route } from "react-router-dom";
import cx from "classnames";
import { Box } from "@mui/material";

import { useAuthContext } from "../../../context";

interface IProps {
  children: React.ReactNode;
  path: string;
  exact?: boolean;
}
const Private = ({ children, ...rest }: IProps): React.ReactElement => {
  const { token, expired } = useAuthContext();

  return (
    <Box className={cx({ "main logged-in": token, main: !token })}>
      <Route
        {...rest}
        render={() =>
          token !== "" && !expired ? (
            children
          ) : (
            <Redirect
              to={{
                pathname: "/login",
              }}
            />
          )
        }
      />
    </Box>
  );
};

export default Private;
